import React, { useState, useEffect } from 'react';
import gameRealtimeClient from '../services/gameRealtimeClient';
import { useAuth } from '../contexts/AuthContext';
import ConnectionSignal from './common/ConnectionSignal';

const ConnectionStatusBanner = () => {
  const { currentUser } = useAuth();
  const [statusState, setStatusState] = useState('connected');
  const [isOnline, setIsOnline] = useState(true);
  const [ping, setPing] = useState(35);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check initial socket state
    const currentOnline = gameRealtimeClient.isOnline();
    const currentState = gameRealtimeClient.connectionState;

    setIsOnline(currentOnline);
    setStatusState(currentState);
    setPing(gameRealtimeClient.getPing ? gameRealtimeClient.getPing() : 35);

    if (!currentOnline || currentState === 'reconnecting' || currentState === 'offline' || currentState === 'reconnected') {
      setVisible(true);
    }

    const unsubscribe = gameRealtimeClient.addStatusListener((state, info) => {
      setStatusState(state);
      setIsOnline(info.isOnline);
      if (info.ping) setPing(info.ping);

      if (state === 'reconnecting' || state === 'offline' || state === 'reconnected') {
        setVisible(true);
      } else if (state === 'connected') {
        setVisible(false);
      }
    });

    return () => unsubscribe();
  }, []);

  // Never show to logged-out users
  if (!currentUser) return null;

  if (!visible || statusState === 'connected') {
    return null;
  }

  return (
    <div
      id="network-status"
      className={`fixed bottom-6 left-6 z-[999999] flex items-center gap-2.5 px-4 py-2 rounded-xl font-bold text-xs tracking-wide transition-all duration-300 transform translate-y-0 select-none ${
        statusState === 'reconnected'
          ? 'bg-emerald-950/95 border border-emerald-500/80 text-emerald-200'
          : statusState === 'offline'
          ? 'bg-rose-950/95 border border-rose-600/80 text-rose-200 animate-pulse'
          : 'bg-stone-900/95 border border-amber-500/80 text-amber-200'
      }`}
    >
      <ConnectionSignal
        ping={ping}
        isOnline={isOnline}
        status={statusState}
        size="sm"
      />
      <span>
        {statusState === 'reconnected'
          ? 'Reconnected to server'
          : statusState === 'offline'
          ? 'Offline - No connection'
          : 'Reconnecting to server...'}
      </span>
    </div>
  );
};

export default ConnectionStatusBanner;

